import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import $ from 'jquery'; // Importa jQuery
window.$ = window.jQuery = $; // Asegúrate de que jQuery está disponible globalmente
Vue.config.productionTip = false
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

